module.exports = __webpack_public_path__ + "img/128.af8aa6c1.jpg";